import { Component, OnInit } from '@angular/core'
import { InlineEditCellDirective } from '../inline-edit-cell'

@Component({
  selector: 'jml-lib-direct-bool-cell',
  templateUrl: './direct-bool-cell.component.html',
  styleUrls: ['../inline-edit-cell.scss']
})
export class DirectBoolCellComponent extends InlineEditCellDirective implements OnInit {
  ngOnInit(): void {}

  triggerEdit() {
    console.log('DirectBoolCellComponent does not implement customEdit')
  }
}
